export class Model {
    id: number;
    code: string;
    name: string;
    state: any;
}